const ru = {
  "comingSoon": "Скоро",
  "soonSub": "Новая охота на троллей",
  "follow": "Следите за новостями",
  "playNow": "Играть на тропе у фьорда",
  "prev": "Предыдущий маршрут",
  "next": "Следующий маршрут",
  "of": "из",
  "readMore": "Подробнее о маршруте",
  "otherTrails": "Новые маршруты в пути",
  "partner": {
    "kicker": "Для бизнеса и муниципалитетов",
    "badge": "Для бизнеса",
    "title": "Станьте партнёром Trollfossjakten.",
    "pitch": "Отели, кафе, сауны, горнолыжные курорты и целые муниципалитеты могут поставить на карту своих троллей. Охота приведёт семьи и туристов прямо к вашей двери — круглый год.",
    "points": [
      "Ваше место отмечено на карте троллей",
      "Гости делают предзаказ и платят через Vipps",
      "Стартовая цена: −50 % для первых 50"
    ],
    "cta": "Стать партнёром",
    "cta2": "Для бизнеса",
    "pin": "Ваш бизнес здесь",
    "stamp": "−50 %"
  },
  "names": {
    "partner": "Партнёрство",
    "fjord": "Тропа у фьорда",
    "stairs": "Midnattsoltrappa",
    "farm": "Тролли Ågård",
    "forest": "Лесная тропа",
    "sea": "Морской маршрут троллей"
  },
  "slides": {
    "stairs": {
      "kicker": "Spansdalen · Lavangen",
      "title": "Лестница полуночного солнца: 20 троллей на 2117 ступенях.",
      "pitch": "Деревянная лестница прямо вверх по склону у Spanstind / Ruŋgugáisá — 380 метров подъёма и вид на долину Spansdalen и Лавангс-фьорд. Двадцать троллей ждут на ступенях, на смотровой площадке и у водопада Henrikkafossen.",
      "stats": [
        [
          "20",
          "троллей"
        ],
        [
          "2117",
          "ступеней"
        ],
        [
          "380",
          "м подъёма"
        ]
      ],
      "note": "Лучше всего под полуночным солнцем в июне и июле."
    },
    "farm": {
      "kicker": "Lavangen · Troms",
      "title": "Тролли Ågård: 30 троллей по другую сторону долины.",
      "pitch": "Совершенно новый участок дороги на другой стороне долины — мимо красных фермерских домов, сушилок для сена, пастбищ с овцами и берега. Фермерские тролли в вязаных шапках прячутся за изгородями и бидонами с молоком.",
      "stats": [
        [
          "30",
          "троллей"
        ],
        [
          "1",
          "новая дорога"
        ],
        [
          "4",
          "сезона"
        ]
      ],
      "note": "Новая дорога — и совсем новая компания троллей."
    },
    "forest": {
      "kicker": "Lavangen · Gratangen",
      "title": "Лесная тропа: 25 троллей среди берёз и сосен.",
      "pitch": "Узкая тропа через замшелый берёзовый и сосновый лес, мимо болот с пушицей, журчащих ручьёв и маленьких мостиков. Моховые тролли в шляпках-грибах выглядывают из-за стволов и валунов.",
      "stats": [
        [
          "25",
          "троллей"
        ],
        [
          "1",
          "лесная тропа"
        ],
        [
          "4",
          "сезона"
        ]
      ],
      "note": "Возьмите фотоаппарат — и немного шоколада."
    },
    "sea": {
      "kicker": "Gratangen · Lavangen · Sjøvegan",
      "title": "Морской маршрут троллей: поймайте Кракена и гигантскую черепаху.",
      "pitch": "Маршрут на лодке по фьорду из Gratangen через Lavangen в Sjøvegan. Под водой ждут морские тролли и два 45-метровых гиганта — Кракен и древняя гигантская черепаха с целым островком на спине.",
      "stats": [
        [
          "15",
          "морских троллей"
        ],
        [
          "45 м",
          "длина гигантов"
        ],
        [
          "3",
          "гавани"
        ]
      ],
      "note": "Отдельный лодочный пакет для платных гостей."
    }
  }
};

export default ru;
